
(function rotate() {
var orientation = window.orientation;
var pd = null;
function createPd() {
if (document.getElementById("preventTran") === null) {
var imgData =
"data:image/png;base64,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";
pd = document.createElement("div");
pd.setAttribute("id", "preventTran");
pd.style.position = "fixed";
pd.style.left = "0";
pd.style.top = "0";
pd.style.width = "100%";
pd.style.height = "100%";
pd.style.overflow = "hidden";
pd.style.backgroundColor = "#03447C";
pd.style.textAlign = "center";
pd.style.zIndex = "99999";
document.getElementsByTagName("body")[0].appendChild(pd);
var img = document.createElement("img");
img.src = imgData;
pd.appendChild(img);
img.style.margin = "60px auto 30px";
var br = document.createElement("br");
var p = document.createElement("p");
p.style.width = "100%";
p.style.height = "auto";
p.style.fontSize = "22px";
p.style.color = "#FFF";
p.style.lineHeight = "34px";
p.style.textAlign = "center";
p.innerHTML = "为了体验更好的视觉效果";
p.appendChild(br);
p.innerHTML += "请竖屏观看/操作";
pd.appendChild(p);
}
}
if (orientation == 90 || orientation == -90) {
if (pd == null && document.getElementById("preventTran") === null)
createPd();
document.getElementById("preventTran").style.display = "block";
}
window.onorientationchange = function() {
if (pd == null && document.getElementById("preventTran") == null)
createPd();
document.getElementById("preventTran").style.display = "none";
rotate();
};
})();
import myHeader from "@/components/myHeader";
import Radio from 'vux/src/components/radio/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Drawer from 'vux/src/components/drawer/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { mapState, mapActions } from "vuex";
import utils from "./utils";
export default {
directives: {
TransferDom
},






components: {
Radio,
Group,
Cell,
Badge,
Drawer,
ButtonTab,
ButtonTabItem,
ViewBox,
XHeader,
Tabbar,
TabbarItem,
Popup,
Loading,
Actionsheet,
myHeader
},
methods: {
handleClosePop() {
this.showPop = false;
},
toSonRotate() {
this.$store.dispatch("setRotate", false);
},
handleMenuClick() {
this.showMenu = !this.showMenu;
},
changeLocale(locale) {
this.$i18n.set(locale);
this.$locale.set(locale);
},
...mapActions(["updateDemoPosition"])
},
mounted() {
this.$store.dispatch("setMobile", utils.isMobile() ? true : false);
this.$store.dispatch("setLang", this.$locale.get());
window.addEventListener(
"resize",
function() {
this.$store.dispatch("setMobile", utils.isMobile() ? true : false);
}.bind(this)
);
},
beforeDestroy() {
this.box && this.box.removeEventListener("scroll", this.handler, false);
},
computed: {
...mapState({
route: state => state.route,

deviceready: state => state.app.deviceready,
demoTop: state => state.vux.demoScrollTop,
isLoading: state => state.vux.isLoading,
direction: state => state.vux.direction,
isMobile: state => state.app.isMobile,
isShowHeader: state => state.app.isShowHeader,
lang: state => state.app.lang
}),
isShowBar() {
if (this.entryUrl.indexOf("hide-tab-bar") > -1) {
return false;
}
return true;
},
isShowNav() {
if (this.entryUrl.indexOf("hide-nav") > -1) {
return false;
}
return true;
},
headerTransition() {
if (!this.direction) return "";
return this.direction === "forward"
? "vux-header-fade-in-right"
: "vux-header-fade-in-left";
},
viewTransition() {
if (!this.direction) return "";
return "vux-pop-" + (this.direction === "forward" ? "in" : "out");
}
},
data() {
return {
isIE: utils.isIE(),
entryUrl: document.location.href,
showMenu: false,
op88888:
String(window.location.href)
.toLowerCase()
.indexOf("op88888") > -1,
showPop: false
};
}
};



// WEBPACK FOOTER //
// ./src/App.vue